import {AppRegistry} from 'react-native';
import App from './App';
import './index.scss';
import {initSentry} from './utils/sentry/instrument';

import './theme.css';
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.dir = () => {};
  console.table = () => {};
  console.group = () => {};
}

initSentry(process.env.REACT_APP_SENTRY_DSN, process.env.REACT_APP_ENV);

AppRegistry.registerComponent('App', () => App);

AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root'),
});
